// TODO: should be interceptor, or write custom get/post function with logic in it
export function getRequiredParams() {
  const currentUrlParams = new URLSearchParams(window.location.search);
  const tab = currentUrlParams.get('tab');
  if (!tab) {
    return {};
  }
  return {
    tab
  };
}